import { useTranslation } from 'react-i18next';
import { DataTableSkeleton, Skeleton } from '@bliks-io/ui';

export function MyTasksSkeleton() {
  const { t } = useTranslation();
  return (
    <div role="status" aria-label={t('common.loading')} className="space-y-8">
      {[1, 2].map((i) => (
        <div key={i} className="space-y-4">
          <div className="space-y-1">
            <Skeleton className="h-6 w-56" />
            <Skeleton className="h-4 w-80" />
          </div>
          <DataTableSkeleton rowCount={3} />
        </div>
      ))}
    </div>
  );
}
